"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayImage = DisplayImage;

var _react = _interopRequireDefault(require("react"));

function DisplayImage(params) {
  var _params$data = params.data,
      name = _params$data.name,
      imageUrl = _params$data.imageUrl,
      image = _params$data.image,
      type = _params$data.type;
  var imgUrl = imageUrl || image;
  var imgAlt = name || type;
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: imgUrl,
    alt: imgAlt,
    className: "image-column"
  });
}